import { useEffect, useRef, useState } from 'react';
import EquipmentWebAPIUtils from 'utils/EquipmentWebAPIUtils';
const RESULT_LIMIT = 25;
const DEBOUNCE_MS = 250;
const MIN_QUERY_LENGTH = 2;
export function useSystemEquipmentSearch({ query, assetType, excludeIds = [], enabled = true, }) {
    const [results, setResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const requestIdRef = useRef(0);
    useEffect(() => {
        const trimmed = (query || '').trim();
        if (!enabled || trimmed.length < MIN_QUERY_LENGTH) {
            setResults([]);
            setIsLoading(false);
            setError(null);
            return undefined;
        }
        setIsLoading(true);
        const currentRequestId = ++requestIdRef.current;
        const handle = setTimeout(() => {
            EquipmentWebAPIUtils.searchEquipment({
                equipment_id: trimmed,
                _equipmentType: assetType,
                per_page: RESULT_LIMIT,
                sort_by: 'equipment_id',
                order: 'asc',
                lean: true,
            }).then((resp) => {
                var _a, _b;
                if (currentRequestId !== requestIdRef.current)
                    return;
                const items = (_b = (_a = resp === null || resp === void 0 ? void 0 : resp.entity) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
                const excludeSet = new Set(excludeIds);
                const filtered = items
                    .filter((item) => !excludeSet.has(item.equipment_id))
                    .slice(0, RESULT_LIMIT);
                setResults(filtered);
                setIsLoading(false);
                setError(null);
            }, (err) => {
                if (currentRequestId !== requestIdRef.current)
                    return;
                setResults([]);
                setIsLoading(false);
                setError(err instanceof Error ? err.message : 'Failed to search equipment');
            });
        }, DEBOUNCE_MS);
        return () => {
            clearTimeout(handle);
        };
    }, [query, assetType, enabled, excludeIds.join('|')]);
    return { results, isLoading, error };
}
